/**
 * Вход через Яндекс ID на русской витрине AiSearch (aisearch.ru).
 *
 * Почему не через наши формы. Формы входа ведут flow Authentik через свой
 * сервер, а Яндекс требует, чтобы человек сам прошёл его страницу в браузере.
 * Поэтому здесь обычный OIDC-вход Auth.js (провайдер `authentik`), только
 * первый шаг идёт не на общую страницу входа, а в поток `yandex-ru-vhod`.
 * В нём одна кнопка источника «Yandex ID» и нет полей, и Authentik сам
 * сразу уводит человека на Яндекс.
 *
 * Почему именно sso.aisearch.ru, а не адрес из issuer. Адрес возврата от
 * Яндекса Authentik строит от домена, на котором идёт поток, а в приложении
 * Яндекса разрешён только `https://sso.aisearch.ru/source/oauth/callback/yandex/`.
 *
 * Что происходит дальше. После Яндекса Authentik входит или заводит
 * пользователя и по параметру `next` возвращает его в authorize того же
 * клиента AiSearch. Тот выдаёт код на обычный адрес возврата Auth.js, и
 * Auth.js меняет его на токены через issuer, как при любом OIDC-входе. Поле
 * `iss` в токенах Authentik ставит по домену запроса обмена (sso.ingdg.com),
 * а параметра `iss` в возврате с кодом не шлёт, поэтому сверка issuer проходит.
 */

/** Authentik русского контура: здесь разрешён возврат от Яндекса. */
export const SSO_AISEARCH_RU = 'https://sso.aisearch.ru';

/** Поток Authentik, который сразу уводит на Яндекс ID. */
export const POTOK_VHODA_YANDEX = 'yandex-ru-vhod';

/**
 * Адрес, с которого начинается вход через Яндекс.
 *
 * Принимает адрес authorize, собранный Auth.js (с его state и PKCE), и
 * оборачивает его в поток входа через Яндекс. `next` обязан быть путём, а не
 * полным адресом: абсолютный Authentik отвергает как «Invalid next URL».
 *
 * Возвращает null, если пришло что-то кроме authorize Authentik: уводить
 * человека по непроверенному адресу нельзя.
 */
export function adresVhodaYandex(authorizeUrl: string): string | null {
  let url: URL;
  try {
    url = new URL(authorizeUrl);
  } catch {
    return null;
  }

  if (url.protocol !== 'https:' || url.pathname !== '/application/o/authorize/') return null;
  if (!url.searchParams.get('client_id') || !url.searchParams.get('redirect_uri')) return null;

  const next = `${url.pathname}${url.search}`;
  return `${SSO_AISEARCH_RU}/if/flow/${POTOK_VHODA_YANDEX}/?next=${encodeURIComponent(next)}`;
}
